<template>
  <v-container :fluid="fluid" class="app-container">
    <slot />
  </v-container>
</template>

<script>
export default {
  name: 'AppContainer',

  props: {
    fluid: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style>
.app-container {
  padding: 10px;
}
</style>